import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CancelButton } from 'components/ui/Button';
import FormattedCurrency from 'components/ui/FormattedCurrency';

import { StyledAccountDetails, StyledRow, StyledCell, StyledLabel } from './BusinessAccountPayment.styles';

const AccountDetails = ({ currency, account, resetQuery, paymentAmount }) => (
  <>
    <h2>
      <FormattedMessage id="baf.title" />
    </h2>

    <StyledAccountDetails>
      {paymentAmount > 0 && (
        <StyledRow>
          <StyledLabel>
            <FormattedMessage id="baf.amount" />
          </StyledLabel>
          <StyledCell>
            <FormattedCurrency amount={paymentAmount} currency={currency} />
          </StyledCell>
        </StyledRow>
      )}

      <StyledRow>
        <StyledLabel>
          <FormattedMessage id="baf.bafCode" />
        </StyledLabel>
        <StyledCell>{account.accountNumber}</StyledCell>
      </StyledRow>

      <StyledRow>
        <StyledCell>
          <FormattedMessage id="baf.companyName" />
        </StyledCell>
        <StyledCell>{account.companyName}</StyledCell>
      </StyledRow>

      <StyledRow>
        <StyledCell>
          <FormattedMessage id="baf.formattedAddress" />
        </StyledCell>
        <StyledCell>{account.formattedAddress}</StyledCell>
      </StyledRow>

      <StyledRow>
        <StyledCell>
          <FormattedMessage id="baf.phoneNumber" />
        </StyledCell>
        <StyledCell>{account.phoneNumber}</StyledCell>
      </StyledRow>

      <StyledRow>
        <StyledCell>
          <FormattedMessage id="baf.status" />
        </StyledCell>
        <StyledCell>{account.status}</StyledCell>
      </StyledRow>
    </StyledAccountDetails>

    <CancelButton onClick={resetQuery}>
      <FormattedMessage id="baf.new" />
    </CancelButton>
  </>
);

AccountDetails.propTypes = {
  currency: PropTypes.string,
  paymentAmount: PropTypes.number,
  account: PropTypes.shape({
    accountNumber: PropTypes.string,
    status: PropTypes.string,
    companyName: PropTypes.string,
    phoneNumber: PropTypes.string,
    formattedAddress: PropTypes.string
  }),
  resetQuery: PropTypes.func.isRequired
};

export default AccountDetails;
